/**
 * Sharable colors definition styles constant
 */

import {css} from "lit";

export const colorsDefStyles = css`
	:host {
		
		/****** colors ************/
		--gray_100 : #000000;
		--gray_90 : #1E1E1E;
		--gray_80 : #373737;
		--gray_70 : #505050;
		--gray_60 : #696969;
		--gray_50 : #828282;
		--gray_40 : #9B9B9B;
		--gray_30 : #B4B4B4;
		--gray_20 : #CDCDCD;
		--gray_10 : #E6E6E6;
		--gray_5 : #F2F2F2;
		--gray_0 : #FFFFFF;
		
		--btn-label-color: #000000;
		
		
		/****** Backgrounds *******/
		--bg_color_0_gray : #FFFFFF;
		--bg_color_5_gray : #FAFAFA;
		--bg_color_10_gray : #F0F0F0;
		--bg_color_15_gray : #D9D9D9;
		--bg_color_20_gray : #CCCCCC;
		--bg_color_25_gray : #BFBFBF;
		--bg_color_30_gray : #B3B3B3;
		--bg_color_40_gray : #999999;
		--bg_color_50_gray : #808080;
		
		--row_hover : rgba(153,204,255,.4);
	}
`;